import { render, staticRenderFns } from "./TrendRecord.vue?vue&type=template&id=6b31d652&scoped=true"
import script from "./TrendRecord.vue?vue&type=script&lang=js"
export * from "./TrendRecord.vue?vue&type=script&lang=js"
import style0 from "./TrendRecord.vue?vue&type=style&index=0&id=6b31d652&prod&scoped=true&lang=css"
import style1 from "./TrendRecord.vue?vue&type=style&index=1&id=6b31d652&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b31d652",
  null
  
)

export default component.exports